/* eslint-disable max-lines */
import * as router_helpers from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import Loader from "@/components/Loader/LoaderView";
import Swal from "sweetalert2";
import EventMediaGallery from "@/components/EventMediaGallery/event_media_gallery.vue";
import EventResource from "@/components/EventResource/event_resource.vue";
import EventSpeaker from '@/components/EventSpeaker/event_speaker.vue';
import EventSponsor from '@/components/EventSponsor/event_sponsor.vue';
import EventAgenda from '@/components/EventAgenda/event_agenda.vue';
import PromoCode from '@/components/PromoCode/event_promo_code.vue';
import EventSurvey from '@/components/EventSurvey/event_survey.vue';
import { client_domain } from "@/main.js";
import * as survey_helper from "@/components/EventSurvey/event_survey_helper";
import base_event_helpers from "./view_event_helpers";
import view_event_component_methods from "./view_event_component_methods_helper";

const event_helpers = {
  ...base_event_helpers,
  ...view_event_component_methods,
};

export default {
  components: {
    HomeNavBar,
    InactivityModal,
    Loader,
    EventMediaGallery,
    EventResource,
    EventSpeaker,
    EventSponsor,
    EventAgenda,
    PromoCode,
    EventSurvey
  },
  data() {
    return ({
      is_loading: true, event: null, error_message: "", event_id: null, show_full_description: false,
      selected_event: {}, event_tickets: [], event_extras: [], selected_item_id: [],
      selected_ticket_id: null, promo_input: "", promo_message: "", promo_status: "",
      applied_promo: null, is_applying: false, scanning: false, show_camera: false,
      scan_result_box: false, scan_success: false, scan_error_message: "",
      scan_data: {}, current_event_id: null, video_stream: null, is_processing: false,
      business_name: "", is_first_time: false, chapter: "",
      chapters: [
        "Bedfordview",
        "Edevale",
        "Kempton Park",
        "Kyalami",
        "East Rand",
      ],
      selected_event_agenda: null, event_ticket_attendees: [], is_submitting: false, cbo_domain: false,
      workbook_domain: false, token_exists: false, show_sponsor_scroll_left: false,
      show_sponsor_scroll_right: false, user_details: {
        user_role: "",
        first_name: "",
        last_name: "",
        user_id: ""
      },
      expanded_creator_survey_id: null,
      show_event_survey_form: false, show_event_survey_answers: false, event_survey_answers: {},
      event_survey_errors: [], event_survey_first_error_question_id: null, event_survey_number_errors: {},
      rsvp_opening_text: "",
    });
  },
  computed: {
    event_survey() {
      return this.event?.survey?.[0]?.survey || null;
    },
    event_survey_questions() {
      return Array.isArray(this.event_survey?.survey_questions)
        ? this.event_survey.survey_questions
        : [];
    },
    event_survey_total_questions() {
      return this.event_survey_questions.length;
    },
    event_survey_answered_count() {
      return this.event_survey_questions.reduce((count, item) => {
        const questionId = item?.question?.id;
        if (!questionId) return count;
        const answer = Reflect.get(this.event_survey_answers, questionId);
        const hasAnswer = Array.isArray(answer)
          ? answer.length > 0
          : typeof answer === "string"
            ? answer.trim().length > 0
            : answer !== undefined && answer !== null && answer !== "";
        return hasAnswer ? count + 1 : count;
      }, 0);
    },
    event_survey_completion_percent() {
      if (!this.event_survey_total_questions) return 0;
      return Math.round((this.event_survey_answered_count / this.event_survey_total_questions) * 100);
    },
    event_surveys() {
      const list = Array.isArray(this.event?.survey) ? this.event.survey : [];
      return list.map((item) => item?.survey || item).filter(Boolean);
    },
    isEventEnded() {
    if (!this.event?.end_date) {
      return false;
    }
    const now = new Date();
    const endDate = new Date(this.event.end_date);
    return now > endDate;
  },
    total_registrations() {
      return event_helpers.total_registrations(this.event);
    },
    capacity_value() {
      return event_helpers.capacity_value(this.event);
    },
    capacity_percent() {
      return event_helpers.capacity_percent(this.total_registrations, this.capacity_value);
    },
    capacity_text() {
      return event_helpers.capacity_text(this.total_registrations, this.capacity_value);
    },
    event_date_line() {
      return event_helpers.event_date_line(this.event);
    },
    event_cover_image() {
      const event_file = this.event?.event_files?.find(
        (file) => file?.event_file_type?.name === "event_profile"
      );
      return event_file?.file?.file_url || this.event?.cover_image || "";
    },
    ticket_breakdown() {
      return event_helpers.ticket_breakdown(this.event);
    },
    can_edit() {
      const userId = this.get_user_id();
      return event_helpers.can_edit(this.token_exists, this.event, this.user_details, userId);
    },
    show_ticket_rsvp_card() {
      const userId = this.get_user_id();
      return event_helpers.show_ticket_rsvp_card(
        this.event,
        this.user_details,
        userId
      );
    },
    gallery_access_allowed() {
      const userId = this.get_user_id();
      return event_helpers.can_view_gallery(
        this.token_exists,
        this.event,
        this.user_details,
        userId,
        this.event_ticket_attendees
      );
    },
    materials_access_allowed() {
      const userId = this.get_user_id();
      return event_helpers.can_view_materials(
        this.token_exists,
        this.event,
        this.user_details,
        userId,
        this.event_ticket_attendees
      );
    },
    gallery_preview() {
      return event_helpers.gallery_preview(this.event, this.gallery_access_allowed);
    },
    has_more_gallery() {
      return event_helpers.has_more_gallery(this.event, this.gallery_access_allowed);
    },
    materials_list() {
      return event_helpers.materials_list(this.event, this.materials_access_allowed);
    },
    materials_preview() {
      return event_helpers.materials_preview(this.materials_list);
    },
    has_more_materials() {
      return event_helpers.has_more_materials(this.materials_list);
    },
    materials_count() {
      return event_helpers.materials_count(this.materials_list);
    },
    description_text_length() {
      return event_helpers.description_text_length(this.event);
    },
    has_long_description() {
      return event_helpers.has_long_description(this.event);
    },
    plain_description() {
      return event_helpers.plain_description(this.event);
    },
    truncated_description() {
      return event_helpers.truncated_description(this.plain_description);
    },
    map_embed_url() {
      return event_helpers.map_embed_url(this.event);
    },
    selected_ticket() {
      return event_helpers.selected_ticket(this.event_tickets, this.selected_ticket_id);
    },
    selected_tickets_total() {
      return event_helpers.selected_tickets_total(this.event_tickets);
    },
  },
  methods: {
    ...survey_helper,
    capitalize_name(value) {
      const name = String(value || "").trim();
      return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
    },
    get_event_organizer_initials(user) {
      const initials = [user?.first_name, user?.last_name]
        .map((name) => String(name || "").trim().charAt(0).toUpperCase())
        .filter(Boolean)
        .join("");
      return initials || "EV";
    },
    format_user_name(user) {
      return [
        this.capitalize_name(user?.first_name),
        this.capitalize_name(user?.last_name),
      ].filter(Boolean).join(" ");
    },
    open_event_survey_form() {
      this.show_event_survey_form = true;
      this.show_event_survey_answers = false;
      this.event_survey_errors = [];
      this.event_survey_first_error_question_id = null;
      this.event_survey_number_errors = {};
    },
    close_event_survey_form() {
      this.show_event_survey_form = false;
      this.event_survey_errors = [];
      this.event_survey_first_error_question_id = null;
      this.event_survey_number_errors = {};
    },
    open_event_survey_answers() {
      this.show_event_survey_answers = true;
      this.show_event_survey_form = false;
    },
    close_event_survey_answers() {
      this.show_event_survey_answers = false;
    },
    set_event_survey_answer(questionId, value) {
      Reflect.set(this.event_survey_answers, questionId, value);
      this.clear_event_survey_error(questionId);
    },
    clear_event_survey_error(questionId) {
      this.event_survey_errors = this.event_survey_errors.filter(
        (error) => String(error.id) !== String(questionId)
      );
      if (String(this.event_survey_first_error_question_id) === String(questionId)) {
        this.event_survey_first_error_question_id = null;
      }
    },
    has_event_survey_error(questionId) {
      return this.event_survey_errors.some((error) => String(error.id) === String(questionId));
    },
    get_event_survey_error(questionId) {
      return this.event_survey_errors.find((error) => String(error.id) === String(questionId))?.message || "";
    },
    get_event_survey_question_type_label(questionType) {
      const labels = {
        yes_no: "Yes / No",
        multiple_choice: "Single choice",
        selection: "Dropdown",
        checkbox: "Multi select",
        text: "Written response",
        paragraph: "Long response",
        text_area: "Long response",
        number: "Number",
        date: "Date",
        link: "Link",
      };

      return Reflect.has(labels, questionType)
        ? Reflect.get(labels, questionType)
        : "Question";
    },
    get_event_survey_display_answers(question) {
      const answers = Array.isArray(question?.answers) ? question.answers : [];
      return answers
        .map((item) => String(item?.answer || "").trim())
        .filter(Boolean)
        .flatMap((answer) => answer.split(",").map((value) => value.trim()).filter(Boolean));
    },
    toggle_creator_survey_details(survey) {
      const surveyId = survey?.id;
      if (!surveyId) return;
      this.expanded_creator_survey_id = this.expanded_creator_survey_id === surveyId ? null : surveyId;
    },
    is_creator_survey_expanded(survey) {
      return this.expanded_creator_survey_id === survey?.id;
    },
    ...event_helpers,
  },
  mounted() {
    this.user_details = router_helpers.get_user_details();
    this.token_exists = !!router_helpers.get_token();
    if (client_domain.includes("cbo")) {
      this.cbo_domain = true;
    }
    if (client_domain.includes("workbook")) {
      this.workbook_domain = true;
    }
    this.fetch_event();

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },
  watch: {
    "$route.params.event_id"() {
      this.fetch_event();
    },
    event: {
      handler() {
        this.$nextTick(() => {
          this.update_sponsor_scroll_controls();
        });
      },
      deep: true
    }
  }
};
